import fetchFile from "../../utils/fetchFile";

/**
 * This function replaces the default elementor arrow icon from FontAwesome to
 * the one used in the client's branding.
 */
const arrowReplacer = () => {

    replaceArrow(
        '/wp-content/uploads/2024/04/arrow.svg',
        'svg.e-fas-arrow-right, .history svg.e-eicon-chevron-right, .history svg.e-eicon-chevron-left'
    );
    replaceArrow(
        '/wp-content/uploads/2024/04/slide-arrow.svg',
        '.brands svg.e-eicon-chevron-right, .brands svg.e-eicon-chevron-left'
    );
    replaceArrow(
        '/wp-content/uploads/2024/11/left-arrow.svg',
        'svg.e-fas-arrow-left'
    );
    replaceArrow(
        '/wp-content/uploads/2024/11/left-arrow-w.svg',
        'svg.e-fas-angle-left'
    );
    replaceArrow(
        '/wp-content/uploads/2024/12/up-arrow.svg',
        'svg.e-fas-arrow-up'
    );

    function replaceArrow(svgPath, selectorToReplace) {
        let arrows = document.querySelectorAll(selectorToReplace);
        let svg;
    
        fetchFile(svgPath, (svgContent) => {
            arrows?.forEach( arrow => {
                // Transform the svg string to a node
                svg = document.createElement('div');
                svg.innerHTML = svgContent;
                svg = svg.firstChild;
                svg.classList.add('e-font-icon-svg');
    
                arrow.parentNode.replaceChild(svg, arrow);
            } );
        });
    }
};

export default arrowReplacer;